import { useCallback, useEffect, useRef, useState } from "react";
import { getLiveStreams, getMainLive, leaveLivePresence, pingLivePresence } from "../lib/api";

const POLL_MS = 15000;
const HEARTBEAT_MS = 25000;

function sessionKey(streamId) {
  return `tv13-live-session-${streamId}`;
}

export function useLiveStreamsPoll(enabled = true) {
  const [streams, setStreams] = useState([]);
  const [main, setMain] = useState(null);

  const refresh = useCallback(() => {
    return Promise.all([getLiveStreams(), getMainLive()])
      .then(([list, mainStream]) => {
        setStreams(list);
        setMain(mainStream);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    const id = window.setInterval(refresh, POLL_MS);
    return () => window.clearInterval(id);
  }, [enabled, refresh]);

  return { streams, main, refresh };
}

export function useLivePresence(streamId, active = true) {
  const sessionRef = useRef(null);
  const [liveViewers, setLiveViewers] = useState("");

  useEffect(() => {
    if (!streamId || !active) return undefined;

    let stopped = false;
    const stored = window.sessionStorage.getItem(sessionKey(streamId));
    sessionRef.current = stored || null;

    const ping = () => {
      pingLivePresence(streamId, sessionRef.current)
        .then((data) => {
          if (stopped) return;
          sessionRef.current = data.sessionId;
          window.sessionStorage.setItem(sessionKey(streamId), data.sessionId);
          setLiveViewers(data.liveViewers);
        })
        .catch(() => {});
    };

    ping();
    const interval = window.setInterval(ping, HEARTBEAT_MS);

    return () => {
      stopped = true;
      window.clearInterval(interval);
      const sid = sessionRef.current;
      if (sid) leaveLivePresence(streamId, sid).catch(() => {});
    };
  }, [streamId, active]);

  return liveViewers;
}
